<template lang="pug">
  .lockup-banner.container.xs-pb-175m(:class="{ 'xs-mt-400m': settings.marginTop, 'xs-pt-400m': settings.paddingTop }" :style="{ background: settings.backgroundColor }")
    .row
      .fixed-width-tweak-upper
        .xs-12.flex-box.column.center-minor-axis.full-width
          .icon(v-if="mediaId" :style="{ background: settings.backgroundColor }")
            .a-box-xs-1x1
              .a-box-content
                img-box(:mediaId="settings.icon.mediaId")
          .xs-12.md-6.xs-f-large.md-f-xlarge.text-center.xs-pb-50m.bold.wide-letter-spacing.max-at-tweak(v-html="settings.title")
          p.color-mr-black.xs-11.md-8.xs-f-small.md-f-medium.text-center.max-at-tweak(v-html="settings.description")

</template>

<script>
  import {getObjProperty} from "@utilities/mrVueUtils";

  export default {
    name: "LockupBanner",
    inject: ['getObjProperty'],
    props: {
      cms: {
        type: Object,
        default: () => {}
      }
    },

    computed: {
      settings() {
        return getObjProperty(this.cms, 'settings') || {};
      },

      mediaId() {
        return getObjProperty(this.cms, 'settings.icon.mediaId');
      }
    }
  };
</script>

<style scoped lang="stylus">
.lockup-banner
  .icon
    margin-top -3em
    border-radius 50%
    width 9em
    height 9em

    .a-box-xs-1x1
      width 7em
      height 7em
      margin 1em

</style>